import { capitalize } from 'lodash';
import { nwsHttpClientInstance } from '@/apis/nwsHttpClient';
import { couponValidateStatusTypeMap } from '@/views/config/coupon/helper/constant';

export const verifyCoupon = async (params = {}) => {
  try {
    const { result } = await nwsHttpClientInstance.post('/opc/verify/coupon', params);

    if (result?.status === couponValidateStatusTypeMap.FAIL) {
      return Promise.reject(result);
    }

    return Promise.resolve(result);
  } catch (e) {
    return Promise.reject({ errorMessage: e?.message });
  }
};

export const validateCoupon = async (params = {}) => {
  try {
    const { result } = await nwsHttpClientInstance.post('/opc/validate/coupon', params);
    const status = result?.type || result?.status;

    if (capitalize(status) === couponValidateStatusTypeMap.SUCCESS) {
      return Promise.resolve();
    } else {
      return Promise.reject({
        ...result,
        errorMessage: result?.message,
      });
    }
  } catch (e) {
    return Promise.reject({ errorMessage: e?.message });
  }
};

export const getMultiCouponPlanList = () => nwsHttpClientInstance.get('/billing/multicoupon/plan/list');
